import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function AtomicMathLayersMobile(): React.ReactElement {
  const { t } = useTranslation('landing')

  return (
    <div className="relative flex justify-center items-center w-screen min-h-[1000px] border-b-2 border-blue-icy overflow-hidden">
      <div className="relative flex justify-start h-full w-50 bg-purple-gmedium-dark mx-auto">
        <div className="bg-purple h-[1000px] w-44" />
        <div className="absolute bg-violet-600 h-[1000px] w-38" />
      </div>
      <ResponsiveImage
        className="absolute min-h-80 w-216 flex justify-center"
        height={981}
        srcKey="landing/bg-layer-mobile.png"
        width={340}
      />
      <div className="absolute min-h-96 w-80 flex justify-center -top-8">
        <div className="relative flex flex-col items-center z-20 max-w-72 text-left mt-44">
          <h3 className="text-5 font-bold mb-2 mr-auto">{t('atomicMath.atomicLearning')}</h3>
          <p>{t('atomicMath.meaningfulBuildingBlocks')}</p>
        </div>
      </div>
      <div className="absolute min-h-96 w-80 flex justify-center mt-[400px]">
        <div className="relative flex flex-col items-center z-20 max-w-72 text-left mt-28">
          <h3 className="text-5 font-bold mb-1 ml-2">{t('atomicMath.BeforeLearning')}</h3>
          <ul className="list-disc list-inside -ml-8">
            <li className="ml-auto">{t('atomicMath.addSub')}</li>
            <li className="ml-auto">{t('atomicMath.multiplication')}</li>
            <li className="ml-auto">{t('atomicMath.fractions')}</li>
            <li className="ml-auto">{t('atomicMath.fractionOp')}</li>
            <li className="ml-auto">{t('atomicMath.signRules')}</li>
            <li className="ml-auto">{t('atomicMath.basicAlgebra')}</li>
            <li className="ml-auto">{t('atomicMath.parentheses')}</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
